import React, { useEffect, useState } from "react";
import "./bdmcontrols.css";

const AdminQuotations = () => {
  const [config, setConfig] = useState(null);
  const [quotations, setQuotations] = useState([]);

  // Load config
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Failed to load config.json:", err));
  }, []);

  // Fetch all quotations
  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.GET_ALL_QUOTATIONS}`, {
      method: "POST",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          console.log("Fetched quotations:", data.data);
          setQuotations(data.data || []);
        }
      })
      .catch((err) => console.error("Error fetching quotations:", err));
  }, [config]);

  // Update quotation status
  const handleStatusUpdate = async (quotation_id, status) => {
    if (!config) return;

    try {
      const response = await fetch(`${config.BASE_URL}${config.UPDATE_QUOTATION_STATUS}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quotation_id, status }),
      });

      const result = await response.json();
      if (result.success) {
        alert(result.message || "Status updated successfully");

        // Remove the updated row from the table
        setQuotations((prev) =>
          prev.filter((q) => q.quotation_id !== quotation_id)
        );
      } else {
        alert(result.message || "Failed to update status");
      }
    } catch (err) {
      console.error("Error updating status:", err);
      alert("Server error while updating status");
    }
  };

  return (
    <div className="quotation-page">
      <h2>Quotation Requests</h2>
      <div className="quotation-table-container">
        <table className="quotation-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Product Name</th>
              <th>Query</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {quotations.length > 0 ? (
              quotations.map((q, index) => (
                <tr key={q.quotation_id}>
                  <td>{index + 1}</td>
                  <td>{q.name}</td>
                  <td>{q.mail}</td>
                  <td>{q.mobileno || "—"}</td>
                  <td>{q.product_name}</td>
                  <td className="query-cell">{q.query}</td>
                  <td>
                    <button
                      className="accept-btn"
                      onClick={() => handleStatusUpdate(q.quotation_id, true)}
                      disabled={q.status === 1}
                    >
                      Accept
                    </button>
                    <button
                      className="decline-btn"
                      onClick={() => handleStatusUpdate(q.quotation_id, false)}
                      disabled={q.status === 2}
                    >
                      Decline
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  No quotations found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminQuotations;
